import Vue from 'vue'

/* For IE11 support -- remove if you don't need IE11 support! (IE11 barely works anyway) */
import 'core-js/stable'
import 'regenerator-runtime/runtime'

/* App specific icons / CSS */
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/css/app.css'

/* For IE11 support -- remove if you don't need IE11 support! (IE11 barely works anyway) */
import '@/assets/css/ie11.css'

/* App settings */
import menuParts from './config/menuParts' // Menu parts for app
import clubSettings from './config/clubSettings' // App specific club settings
import appUser from './config/user' // App specific user fields
import appConfig from './config/appConfig' // App specific app configuration fields

/* Core App Components */
import AppDining from '@/AppDining.vue'
import AppPOS from '@/AppPOS.vue'
import AppSupport from '@/AppSupport.vue'

/* Helpers */
import {modeFromLocation} from '@/ft-vue-core/util/helpers'

/* Build ForeTees app */
import ftVueCore from '@/ft-vue-core'

// Select core app by app mode
const appMode = modeFromLocation()
var app

switch (appMode) {
case 'dining':
  app = AppDining
  break
case 'pos':
  app = AppPOS
  break
case 'support':
  app = AppSupport
  break
default:
  console.error('No App defined for appMode: ' + appMode)
}

/* Create root Vue app */
const ftApp = new Vue({
  ...ftVueCore(
    // App settings (used to extend Vuex store)
    {
      menuParts, // Used when building menus
      clubSettings, // access via this.$ftCS
      appUser, // access via this.$ftUser
      appConfig // Access via this.$ftAC
    },
    process.env
  ),
  render: h => h(app)
}).$mount('#app')

/* Store app instance in window object for use by methods out of Vue context. (There's probably a better way to do this.) */
window.$ftApp = ftApp
